import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportGenerateFormModel } from './report-generate-form.model';
import { ReportName } from '../../../../../../shared/enums/report-name.enum';
import { ComparisionCycle } from '../../../../../../shared/enums/comparision-cycle.enum';

export class ReportGenerateFormBuilder {
  static createFormGroup(): FormGroup<ReportGenerateFormModel> {
    return new FormGroup<ReportGenerateFormModel>({
      nazwa: new FormControl<ReportName | null>(null, {
        validators: [Validators.required],
        nonNullable: false,
      }),
      dataOd: new FormControl<Date | null>(null),
      dataDo: new FormControl<Date | null>(null),
      cykl: new FormControl<ComparisionCycle | null>(null),
      rok: new FormControl<Date | null>(null),
      doRoku: new FormControl<Date | null>(null),
      polrocze: new FormControl<number | null>(null),
      doPolrocza: new FormControl<number | null>(null),
      kwartal: new FormControl<number | null>(null),
      doKwartalu: new FormControl<number | null>(null),
      miesiac: new FormControl<number | null>(null),
      doMiesiac: new FormControl<number | null>(null),
      rodzajWnioskuCode: new FormControl<string[] | null>([]),
      statusWniosku: new FormControl<string[] | null>([]),
    });
  }

  static applyConditionalRules(
    formGroup: FormGroup<ReportGenerateFormModel>,
  ): void {
    const isBasic =
      formGroup.controls.nazwa.value === ReportName.BASIC_APPLICATION_REPORT;
    const isComparative =
      formGroup.controls.nazwa.value ===
      ReportName.COMPARATIVE_APPLICATION_REPORT;
    const cycle = formGroup.controls.cykl.value;

    this.toggleRequired(formGroup.controls.dataOd, isBasic);
    this.toggleRequired(formGroup.controls.dataDo, isBasic);

    if (!isBasic) {
      this.clearControl(formGroup.controls.dataOd);
      this.clearControl(formGroup.controls.dataDo);
    }

    this.toggleRequired(formGroup.controls.cykl, isComparative);
    this.toggleRequired(formGroup.controls.rok, isComparative);
    this.toggleRequired(formGroup.controls.doRoku, isComparative);

    if (!isComparative) {
      this.clearControl(formGroup.controls.cykl);
      this.clearControl(formGroup.controls.rok);
      this.clearControl(formGroup.controls.doRoku);
      this.clearControl(formGroup.controls.polrocze);
      this.clearControl(formGroup.controls.doPolrocza);
      this.clearControl(formGroup.controls.kwartal);
      this.clearControl(formGroup.controls.doKwartalu);
      this.clearControl(formGroup.controls.miesiac);
      this.clearControl(formGroup.controls.doMiesiac);
    }

    this.toggleRequired(
      formGroup.controls.polrocze,
      isComparative && cycle === ComparisionCycle.HALF_YEAR,
    );
    this.toggleRequired(
      formGroup.controls.doPolrocza,
      isComparative && cycle === ComparisionCycle.HALF_YEAR,
    );

    this.toggleRequired(
      formGroup.controls.kwartal,
      isComparative && cycle === ComparisionCycle.QUARTER,
    );
    this.toggleRequired(
      formGroup.controls.doKwartalu,
      isComparative && cycle === ComparisionCycle.QUARTER,
    );

    this.toggleRequired(
      formGroup.controls.miesiac,
      isComparative && cycle === ComparisionCycle.MONTH,
    );
    this.toggleRequired(
      formGroup.controls.doMiesiac,
      isComparative && cycle === ComparisionCycle.MONTH,
    );

    if (cycle !== ComparisionCycle.HALF_YEAR) {
      this.clearControl(formGroup.controls.polrocze);
      this.clearControl(formGroup.controls.doPolrocza);
    }

    if (cycle !== ComparisionCycle.QUARTER) {
      this.clearControl(formGroup.controls.kwartal);
      this.clearControl(formGroup.controls.doKwartalu);
    }

    if (cycle !== ComparisionCycle.MONTH) {
      this.clearControl(formGroup.controls.miesiac);
      this.clearControl(formGroup.controls.doMiesiac);
    }

    formGroup.updateValueAndValidity({ emitEvent: false });
  }

  static toggleRequired(
    control: FormControl<unknown>,
    required: boolean,
  ): void {
    if (required) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  static clearControl(control: FormControl<unknown>): void {
    control.reset(null, { emitEvent: false });
    control.markAsUntouched();
  }
}
